import { createSlice } from "@reduxjs/toolkit";

const notification = createSlice({
  name: "notification",
  initialState: {
    isConnected: false,
    socket: null,
    notificationNum: 0,
    notificationList: [],
  },
  reducers: {
    notificationListValue: (state, action) => {
      state.notificationList = action.payload.notificationValue;
    },
    appendNotification: (state, action) => {
      state.notificationList = [
        ...state.notificationList,
        action.payload.notification
      ];
    },
    notificationNumValue: (state, action) => {
      state.notificationNum = action.payload.notificationNum;
    },
    connectNotificationSocket: (state, action) => {
      state.isConnected = true;
      state.socket = action.payload;
    },
    disConnectNotificationSocket: (state, action) => {
      state.isConnected = false;
      state.socket = null;
    },
  },
});

export const {
  notificationListValue,
  notificationNumValue,
  appendNotification,
  connectNotificationSocket,
  disConnectNotificationSocket,
} = notification.actions;
export default notification.reducer;
